import React from 'react';

import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';

interface QuoteErrorDialogProps {
    message: string | null;
    onClose: () => void;
}

/** Quote access error; closing it leaves the page (onClose redirects). */
const QuoteErrorDialog: React.FC<QuoteErrorDialogProps> = ({ message, onClose }) => (
    <Dialog
        open={message !== null}
        onClose={onClose}
        maxWidth="xs"
        fullWidth
        PaperProps={{ sx: { bgcolor: '#fff', borderRadius: 2 } }}
    >
        <DialogContent>
            <Typography sx={{ color: '#000' }}>{message}</Typography>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
            <Button variant="contained" onClick={onClose} autoFocus>Rendben</Button>
        </DialogActions>
    </Dialog>
);

export default QuoteErrorDialog;
